import { find } from 'lodash';
import { SUPPORTED_FIVERR_LOCALES, getShortLanguageCode } from '@fiverr-private/localization';

export const isSupportedFiverrLanguage = (assumedLanguage) =>
    find(SUPPORTED_FIVERR_LOCALES, (locale) => getShortLanguageCode(locale) === assumedLanguage);
